import { useEffect } from 'react'
import { ReactBootstrapSlider } from 'react-bootstrap-slider'
import { HelpBlock } from 'react-bootstrap'

import QuestionStandardTop from './QuestionStandardTop'

const RatingQuestion = ({ question, response, errors, validateResponse, onRespond }) => {
  const minVal = (question && question.minValue) || 0
  const maxVal = (question && question.maxValue) || 0
  const ticks = new Array(maxVal - minVal + 1).fill().map((item, idx) => minVal + idx)
  const tickLabels = ticks.map(tick => {
    if (tick < minVal) {
      return ''
    }

    return `${tick}`
  })

  useEffect(() => {
    if (!response) {
      onRespond(question, minVal, false)
    }
  }, [response, minVal, question, onRespond])

  return (
    <div>
      <QuestionStandardTop question={question} />
      <div className="col-xs-12 slider-holder">
        <ReactBootstrapSlider
          value={response ?? minVal}
          selection="none"
          step={1}
          change={async evt => {
            let responded = onRespond(question, evt.target.value, false)

            if (responded instanceof Promise) {
              responded = await responded
            }

            validateResponse(question, responded.response)
          }}
          min={minVal}
          max={maxVal}
          ticks={ticks}
          ticks_snap_bounds="30"
          ticks_labels={tickLabels}
        />
      </div>
      <div className="row">
        <div className="col-xs-6">{question.minValueExplanation}</div>
        <div className="col-xs-6 text-right">{question.maxValueExplanation}</div>
      </div>
      {errors && <HelpBlock>{errors}</HelpBlock>}
    </div>
  )
}

export default RatingQuestion
